import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

export const ModalOption = {
  isModal: true
};

export const nestedFormKeys = {
  country_id: 'country_id',
  state: 'state',
  city: 'city',
  street: 'street',
  zip: 'zip'
};

export const ALL_FORM_FIELDS = {
  ...nestedFormKeys,
  display_id: 'display_id',
  name: 'name',
  contact_person: 'contact_person',
  phone: 'phone',
  email: 'email'
};

export const EditClientForm = new UntypedFormGroup({
  display_id: new UntypedFormControl(''),
  name: new UntypedFormControl('', [Validators.required]),
  contact_person: new UntypedFormControl(''),
  email: new UntypedFormControl('', [Validators.email]),
  phone: new UntypedFormControl(''),
  billing_address: new UntypedFormGroup({
    country_id: new UntypedFormControl(''),
    street: new UntypedFormControl(''),
    city: new UntypedFormControl(''),
    state: new UntypedFormControl(''),
    zip: new UntypedFormControl('')
  }),
  shipping_address: new UntypedFormGroup({
    country_id: new UntypedFormControl(''),
    street: new UntypedFormControl(''),
    city: new UntypedFormControl(''),
    state: new UntypedFormControl(''),
    zip: new UntypedFormControl('')
  })
});
